import drmApi from '@/services/drmApi'
import foldersApi from '@/services/foldersApi'

const updateUser = async ({ commit }, userCredentials) => {
  try {
    commit('UPDATE_USER_INFO', userCredentials)
  } catch (e) {
    commit('UPDATE_GLOBAL_SNACKBAR', {
      open: true,
      text: `${e}, contate o suporte para mais informações.`,
    })
  }
}

const logoutUser = async ({ commit }) => {
  commit('UPDATE_USER_INFO', null)
  commit('signOut')
}

const updateUserFolders = async ({ commit }) => {
  try {
    const ret = await foldersApi.getUserFolders()
    let notDeletedFolders = ret.data.folders.filter(
      (folder) => folder.status != false
    )
    let deletedFolders = ret.data.folders.filter(
      (folder) => folder.status === false
    )
    commit('UPDATE_MAIN_FOLDERS', notDeletedFolders)
    commit('UPDATE_DELETED_FOLDERS', deletedFolders)
    commit('UPDATE_ALL_FOLDERS', ret.data.folders)
  } catch (e) {
    console.error(e)
  }
}

const addVideo = ({ commit, state }, video) => {
  let newVideosArray = state.mainVideos
  newVideosArray.unshift(video)
  commit('UPDATE_MAIN_VIDEOS', newVideosArray)
}

const editVideo = ({ commit, state }, video) => {
  let newVideosArray = state.mainVideos.map((item) =>
    item.id == video.id ? video : item
  )
  commit('UPDATE_MAIN_VIDEOS', newVideosArray)
}

const removeVideo = ({ commit, state }, video) => {
  let newVideosArray = state.mainVideos.filter((item) => item.id != video.id)
  commit('UPDATE_MAIN_VIDEOS', newVideosArray)
}

const addFolder = ({ commit, state }, folder) => {
  let newAllFoldersArray = state.allFolders
  newAllFoldersArray.unshift(folder)
  let newFoldersArray = state.mainFolders
  newFoldersArray.unshift(folder)
  commit('UPDATE_MAIN_FOLDERS', newFoldersArray)
  commit('UPDATE_ALL_FOLDERS', newAllFoldersArray)
}

const editFolder = ({ commit, state }, folder) => {
  let newFoldersArray = state.mainFolders.map((item) =>
    item.id == folder.id ? folder : item
  )
  let newAllFoldersArray = state.allFolders.map((item) =>
    item.id == folder.id ? folder : item
  )
  commit('UPDATE_MAIN_FOLDERS', newFoldersArray)
  commit('UPDATE_ALL_FOLDERS', newAllFoldersArray)
}

const removeFolder = ({ commit, state }, folderId) => {
  let foundFolder = state.allFolders.find((item) => item.id === folderId)
  let newFoldersArray = state.mainFolders.filter((item) => item.id != folderId)
  let newAllFoldersArray = state.allFolders.map((item) =>
    item.id == folderId ? { ...foundFolder, status: false } : item
  )
  let newDeletedFolders = [
    ...state.deletedFolders,
    { ...foundFolder, status: false },
  ]
  commit('UPDATE_MAIN_FOLDERS', newFoldersArray)
  commit('UPDATE_DELETED_FOLDERS', newDeletedFolders)
  commit('UPDATE_ALL_FOLDERS', newAllFoldersArray)
}

const recoverFolder = ({ commit, state }, folderId) => {
  let foundFolder = state.allFolders.find((item) => item.id === folderId)
  let newFoldersArray = [...state.mainFolders, { ...foundFolder, status: true }]
  let newAllFoldersArray = state.allFolders.map((item) =>
    item.id == folderId ? { ...foundFolder, status: true } : item
  )
  let newDeletedFolders = state.deletedFolders.filter(
    (item) => item.id != folderId
  )
  commit('UPDATE_MAIN_FOLDERS', newFoldersArray)
  commit('UPDATE_ALL_FOLDERS', newAllFoldersArray)
  commit('UPDATE_DELETED_FOLDERS', newDeletedFolders)
}

const addSubFolderVideo = ({ commit, state }, video) => {
  let newSubFolderArray = state.subFolderVideos
  newSubFolderArray.unshift(video)
  commit('UPDATE_SUB_FOLDER_VIDEOS', newSubFolderArray)
}

const editSubFolderVideo = ({ commit, state }, video) => {
  let newSubFolderArray = state.subFolderVideos.map((item) =>
    item.id == video.id ? video : item
  )
  commit('UPDATE_SUB_FOLDER_VIDEOS', newSubFolderArray)
}

const removeSubFolderVideo = ({ commit, state }, video) => {
  let newSubFolderArray = state.subFolderVideos.filter(
    (item) => item.id != video.id
  )
  commit('UPDATE_SUB_FOLDER_VIDEOS', newSubFolderArray)
}

const updateAccountFolderVideos = ({ commit, state }, data) => {
  let actualState = state.accountFolderVideos
  actualState[`${data.id}`] = data.videos
  commit('UPDATE_ACCOUNT_FOLDER_VIDEOS', actualState)
}

const loadDrmGroups = async ({ state }) => {
  state.drmData.loadings.drmGroups = true

  try {
    let ret = await drmApi.getDrm()
    state.drmData.isDrmActive = ret.data.status

    if (ret.data.status) await getDrmGroups(state)
  } catch (error) {
    console.error(error)
  }

  state.drmData.loadings.drmGroups = false
}

const getDrmGroups = async (state) => {
  try {
    let ret = await drmApi.getDrmGroups()
    state.drmData.drmGroups = ret.data
  } catch (error) {
    console.error(error)
  }
  state.drmData.loadings.drmGroups = false
}

export {
  updateUser,
  logoutUser,
  updateUserFolders,
  addVideo,
  editVideo,
  removeVideo,
  addFolder,
  editFolder,
  removeFolder,
  recoverFolder,
  addSubFolderVideo,
  editSubFolderVideo,
  removeSubFolderVideo,
  updateAccountFolderVideos,
  loadDrmGroups,
}
